import { Settings } from "../../Settings";
import NumberValue from "../value/NumberValue";
import SkillActivationTimer from "./SkillActivationTimer";

export default class SkillActivationTracker {
    /**
     * 
     * @param {number} groupOffset 
     * @param {NumberValue} durationUpgrades
     * @param {NumberValue} coolDownUpgrades
     */
    constructor(groupOffset, durationUpgrades, coolDownUpgrades) {
        /**
         * @constant
         * @type {number}
         */
        this.groupOffset = groupOffset;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.durationUpgrades = durationUpgrades;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.coolDownUpgrades = coolDownUpgrades;
        /**
         * Minimum turns between skill activations.
         * @constant
         * @type {number}
         */
        this.staggeredTurns = Settings.time.turnsPerSecond * 20; 

        /**
         * @constant
         * @type {SkillActivationTimer[]}
         */
        this.activationTimers = [];
    }

    /**
     * @param {number} turnNumber
     * @param {number} minerCount 
     */
    setMinerCount(turnNumber, minerCount) {

        while (this.activationTimers.length < minerCount) {
            this.activationTimers.push(new SkillActivationTimer(this.durationUpgrades, this.coolDownUpgrades));
        }

        this.initializeTimers(turnNumber);
    }

    /**
     * @private
     * @param {number} turnNumber 
     */
    initializeTimers(turnNumber) {
        let minerOffset = 0;
        for (let i = 0; i < this.activationTimers.length; i++) {
            this.activationTimers[i].initialize(turnNumber, this.groupOffset + minerOffset); 
            minerOffset += this.staggeredTurns;
        }
    }

    /**
     * 
     * @param {number} turnNumber 
     */
    updateForTurn(turnNumber) {

        // Update all the timers.
        for (let i = 0; i < this.activationTimers.length; i++) {
            this.activationTimers[i].updateForTurn(turnNumber);
        }
    }

    /**
     * @param {number} minerIndex 
     * @returns {boolean}
     */
    isSkillActive(minerIndex) {
        return this.activationTimers[minerIndex].isSkillActive();
    }

    resetForPrestige() {
        this.initializeTimers(0);
    }
}